import { isEmpty } from "lodash-es";
import WujiTips from "../../../tools/wujiTips";
import { isAxiosError } from "../../../tools/axios";
const authInvalidCollIdKey = 'xy-auth-invalid-coll-id';
const get403Href = (projectId, data) => {
  var _p403Info$query$repla, _p403Info$query;
  const {
    origin,
    pathname
  } = location;
  const {
    pathPrefix
  } = window.GLOBAL_INFO;
  const p403Info = getPage403Info();
  const p403 = p403Info.path || '/403';
  const search = isEmpty(data) ? '' : String(new URLSearchParams(data));
  const query403 = p403Info.path ? (_p403Info$query$repla = (_p403Info$query = p403Info.query) === null || _p403Info$query === void 0 ? void 0 : _p403Info$query.replace(/^\?/, '')) !== null && _p403Info$query$repla !== void 0 ? _p403Info$query$repla : '' : '';
  const searchPart = [query403, search].filter(Boolean).join('&');
  let path = p403;
  if (pathname.startsWith(`${pathPrefix}/xy/app/`)) {
    const [prefix] = pathname.split(`/${projectId}/`);
    path = `${prefix}/${projectId}${p403}`;
  } else if (pathname.startsWith('/page/')) {
    path = `/page${p403}`;
  }
  const result = `${origin}${path}${searchPart ? `?${searchPart}` : ''}`;
  return result;
};
const getPage403Info = () => {
  const {
    page403 = ''
  } = window.xy_runtime_project;
  let p403Info = {
    path: '',
    query: ''
  };
  if (page403 !== null && page403 !== void 0 && page403.startsWith('{')) {
    try {
      p403Info = JSON.parse(page403);
    } catch (error) {
      // ignore
    }
  } else if (page403 !== null && page403 !== void 0 && page403.startsWith('/')) {
    p403Info = {
      path: page403,
      query: ''
    };
  }
  return p403Info;
};
/**
 * 错误处理插件
 * @param ctx
 * @param next
 * @returns
 */
export const handleError = async (ctx, next) => {
  try {
    await next();
  } catch (error) {
    if (!isAxiosError(error)) {
      throw error;
    }
    const {
      response
    } = error;
    const body = response === null || response === void 0 ? void 0 : response.data;
    if ((response === null || response === void 0 ? void 0 : response.status) === 403) {
      const {
        projectId
      } = ctx;
      const target = get403Href(projectId, body === null || body === void 0 ? void 0 : body.data);
      const wujiTips = new WujiTips();
      wujiTips.error({
        content: h => h('span', {}, ['无权调用，点击', h('a', {
          attrs: {
            href: target,
            target: '_blank'
          }
        }, ['申请权限'])]),
        title: '权限校验失败',
        duration: 5
      });
    }
    throw error;
  } finally {
    const res = ctx.response;
    if (res !== null && res !== void 0 && res.headers[authInvalidCollIdKey] && !!window.RUNTIME_CONFIGS) {
      const collId = res.headers[authInvalidCollIdKey];
      const wujiTips = new WujiTips();
      if (window.RUNTIME_CONFIGS.isPreviewMode) return;
      wujiTips.error({
        content: `请在当前页面引入数据源 ${collId} (引入后因缓存不会立即生效), 或给对应的数据源接口绑定自定义权限`,
        title: '页面数据源关联校验失败',
        duration: 5
      });
    }
  }
};
//# sourceMappingURL=handleError.js.map
